import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { adminActions } from '../../../actions/adminActions';
import { getForms } from '../../../actions/formActions';
import SearchBox from '../../Common/SearchBox/SearchBox';

const AdminActions = () => {
    const searchBoxKey = 'admin_home_search_form';
    const listFormKey = '';
    const dispatch = useDispatch();
    const { formJson = {} } = useSelector((state) => state.forms);
    const { actionsResponse = [] } = useSelector((state) => state.admin);
    const searchBoxJson = formJson[searchBoxKey] || {};
    const [fetchingSearchForm, setFetchingSearchForm] = useState(_.isEmpty(searchBoxJson));
    const [fetchingList, setFetchingList] = useState(false);

    useEffect(() => {
        if (_.isEmpty(searchBoxJson)) dispatch(getForms(searchBoxKey, listFormKey));
    }, []);

    useEffect(() => {
        if (!_.isEmpty(searchBoxJson) && fetchingSearchForm) setFetchingSearchForm(false);
    }, [searchBoxJson]);

    useEffect(() => {
        if (!_.isEmpty(actionsResponse)) {
            setFetchingList(false);
            toast.success('Successfully completed');
        }
    }, [actionsResponse]);

    const handleSearch = (data) => {
        setFetchingList(true);
        dispatch(adminActions(data));
    };

    return <SearchBox searchBoxJson={searchBoxJson} onSearch={handleSearch} fetchingForm={fetchingSearchForm} fetchingList={fetchingList} />;
};

export default AdminActions;
